import React, { useState } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";
import { DockyardServices } from "$services";
import { DockyardStatus } from "$types/DockyardStatus";
import { Fiability } from "$types/Fiability";
import useAuth from "./useAuth";

export interface IDockyard {
  _id?: string;
  project?: string;
  code: string;
  codeAnalytics?: string;
  name: string;
  address: string;
  address2?: string;
  postalCode: string;
  city: string;
  country: string;
  company: string;
  contact: string;
  fiability: Fiability;
  status: DockyardStatus;
  date: string;
  lastnameContact?: string;
  firstnameContact?: string;
  emailContact?: string;
  phoneContact?: string;
  isDisable?: boolean;
  updateAt: string;
  projectDisable?: boolean;
  companyDisable?: boolean;
  notes?: string;
  interveningCompany?: any[];
  medias?: string[];
}

const useDockyardForm = (postSubmitAction?: any, externalTogglePopin?: any) => {
  const { token } = useAuth();
  const classes = useStyles();

  // states
  const [submitting, setSubmitting] = useState(false);
  const [isOpened, setOpen] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");
  const [dockyard, setDockyard] = useState<any>(null);

  const openPopin = async (dockyardId?: string) => {
    if (dockyardId) {
      const dockyardData = await DockyardServices.getDockyardById(dockyardId);
      setDockyard(dockyardData);
    } else {
      setDockyard(null);
    }
    setOpen(true);
  };

  const togglePopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
      setDockyard(null);
    }
    setOpen(isOpen);
  };

  const handleSubmit = async (data: any) => {
    setSubmitting(true);
    const dockyardId = data._id || data.id;
    const Service = dockyardId
      ? DockyardServices.UpdateDockyard
      : DockyardServices.AddDockyard;

    try {
      const body = await Service(token, data, dockyardId);

      if (body?.error) {
        setError(body.error);
      } else {
        togglePopin(false);
        externalTogglePopin?.();
        setError("");
        postSubmitAction?.();
      }
      return body;
    } catch (err: any) {
      setError(err.error || err.message || "Erreur Serveur");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    classes,
    openPopin,
    togglePopin,
    handleSubmit,
    error,
    dockyard,
    isOpened,
    submitting,
  };
};

export default useDockyardForm;

const useStyles = createUseStyles(() => ({
  LayoutCustom: {
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
  },
  ProjectsPage: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: "0px",
    "& td.MuiTableCell-body:first-child": {
      fontWeight: "bold",
    },
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
    },
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
  },
  ProjectsPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
    "& .bordered": {
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid #d8dadc",
      "& h3:not(:first-child)": {
        marginLeft: "10px",
      },
    },
  },
  SwitchControl: {
    paddingLeft: 10,
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
  },
  ProjectsPage__AddCta: {
    marginRight: "10px !important",
  },
  TableRowCode: {
    "& > div span": {
      color: theme.color.blue,
    },
    "&.disabled": {
      "& span": {
        color: `${theme.color.gray3} !important`,
      },
    },
  },
  RowBold: {
    "& span": {
      fontWeight: "500",
    },
    "&.disabled": {
      "& span": {
        color: `${theme.color.gray3} !important`,
      },
    },
  },
  select: {
    flex: "1",
    paddingRight: "20px",
    "&:last-child": {
      padding: 0,
    },
    background: theme.color.white,
    "& .MuiInputLabel-shrink": {
      background: `${theme.color.white} !important`,
    },
  },
  selectInput: {
    flex: 1,
    border: `1px solid ${theme.color.gray2}`,
    paddingLeft: 10,
    paddingRight: 10,
    "&:before": {
      display: "none",
    },
    "& .MuiInput-input": {
      height: 29,
      fontSize: 15,
      display: "flex",
      alignItems: "center",
    },
  },
  NoResultPlaceHolder: {
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& h3": {
      position: "relative",
      top: "-130px",
    },
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: "300px",
      background: theme.color.white,
    },
  },
  DatePicker: {
    width: "100%",
    "& .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
      right: "10px !important",
    },
  },
}));
